// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__bgqRM","requiredAsterisk":"Info_requiredAsterisk__2OYb1"};